
<template>
  <div class="console-container">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'Console'
}
</script>

<style scoped>
.console-container {
  width: 100%;
  height: 100%;
}
</style>
